import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import store from "./store";
import { Provider } from "react-redux";
import { AppRootContainer } from "./app-root/app-root.container";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./global.css";

function App() {
  useEffect(() => {
    if (localStorage.getItem("bhabhuti-session") == null) {
      localStorage.setItem("bhabhuti-session", crypto.randomUUID());
    }
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter
        future={{
          v7_startTransition: true, // ✅ fixes React Router warning 1
          v7_relativeSplatPath: true, // ✅ fixes React Router warning 2
        }}
      >
        <ToastContainer />
        <AppRootContainer />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
